"use client";

import { SuperLink as Link } from "@/components/common/super-link";
import { createPath } from "@/service/routing/routing";
import { useContext, useEffect } from "react";
import { logEvent } from "@/service/logs/log";
import { ResourceContext } from "@/contexts/resource-context";
import { Icd10Inn } from "./icd10-inn";
import { MedStatusBadge } from "@/components/meds/med-status-badge";
import { EXCLUDED_INN_NAME } from "@/components/meds/excluded-inn";

export const Icd10Med = ({
  med,
  code,
}: {
  med: MedGroupPreviewVM;
  code: string;
}) => {
  const { logView } = useContext(ResourceContext);
  const { title, slug, id, status, inns, featured } = med;

  const link = createPath("meds.group.show", {
    slug,
    id,
  });

  useEffect(() => {
    if (featured) {
      logEvent("search_med_view", logView, {
        resourceTitle: title,
        resourceURL: createPath("meds.group.show", {
          slug,
          id,
        }),
        query: null,
        is_global_search: false,
      });
    }
  }, []);

  return (
    <div className={"flex flex-wrap gap-4 px-2 py-2.5"}>
      <MedStatusBadge status={status} />
      {featured && (
        <span className={`text-remedium-blue text-xs font-medium`}>
          &nbsp; REKLAMA
        </span>
      )}
      <Link
        href={link}
        onClick={() => {
          logEvent("icd10_internal_link_click", logView, {
            icd_code: code,
            resource_path: link,
            resource_type: "med",
          });
        }}
        className={`text-foreground text-remedium-blue-hover text-base font-bold`}
      >
        {title}
      </Link>
      {inns.find((inn) => inn.name !== EXCLUDED_INN_NAME) && (
        <div className={`flex items-start gap-2`}>
          <div className={`text-sidebar-foreground text-sm font-normal`}>
            Preparat zawiera:{" "}
          </div>
          {inns.map((inn, index) => (
            <Icd10Inn code={code} inn={inn} key={index} />
          ))}
        </div>
      )}
    </div>
  );
};
